// ----------------------------------------------------------------------------
// Template: Search
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/pagination/pagination';
import 'snippets/search-form/search';
import 'sections/header/header';
import 'sections/page-hero/page-hero';
import 'sections/main-search/main-search';
import 'sections/footer/footer';